define('util/dom-queues',[ "promise", "util/raf" ], function( Promise, rAF ) {

	"use strict";

	var
		error  = { value : null },
		global = this,
		reads  = [],
		writes = [];

	var flush = rAF.defer( function flush() {
		var task;

		while ( task = reads.shift()) { task(); }
		while ( task = writes.shift()) { task(); }
	});

	// This utility function isolates the `try ... catch` statements
	// that would otherwise reside in `schedule` into a function that
	// always returns a value and has a catch path that does not call
	// into further functions or perform complex state manipulation.
	
	// To recognize whether a catch occured, the calling function inside
	// `schedule` will check whether the return value equals the global
	// `error` object and if it does, lifts the actual thrown error
	// out of its `value` property.
	function tryCatch( fn, context, cancel ) {
		try {
			return fn.call( context, cancel );
		} catch( err ) {
			error.value = err;
			return error;
		}
	}

	function schedule( queue, fn, context ) {
		// rAF.defer is async on next frame, so we can call
		// this here to schedule flushing of the now populated
		// queues.
		flush();

		context = context || global;

		return new Promise( function( resolve, reject ) {
			function cancel() {
				reject( new Error( "cancelled" ));
			}

			queue.push( function() {
				var result;

				if ( typeof fn === "function" ) {
					result = tryCatch( fn, context, cancel );
					if ( result === error ) {
						reject( error.value );
						return;
					}
				} else {
					result = fn;
				}

				resolve( result );
			});
		});
	}

	return {
		read : function read( fn, context ) {
			return schedule( reads, fn, context );
		},

		write : function write( fn, context ) {
			return schedule( writes, fn, context );
		}
	};
});
